import React from "react";
import { AbsoluteFill, Img, Video, staticFile } from "remotion";
import bgConfig from "./bg_config.json";

interface BackgroundProps {
  theme?: "light" | "dark" | "none";
  opacity?: number;
}

export const Background: React.FC<BackgroundProps> = ({
  theme = "dark",
  opacity = 1,
}) => {
  if (bgConfig.type === "none" || !bgConfig.path) {
    return null;
  }

  const fileUrl = staticFile(bgConfig.path);
  const isImage = bgConfig.type === "image";

  // Premium brand-aligned overlays to ensure text readability
  const overlayStyle: React.CSSProperties = {
    position: "absolute",
    inset: 0,
    zIndex: 1,
    pointerEvents: "none",
  };

  if (theme === "dark") {
    // Sleek dark overlay matching brand dark bg
    overlayStyle.background = "linear-gradient(180deg, rgba(28, 25, 23, 0.75) 0%, rgba(41, 37, 36, 0.88) 100%)";
  } else if (theme === "light") {
    // Light editorial overlay matching brand light warm
    overlayStyle.background = "linear-gradient(180deg, rgba(249, 248, 254, 0.82) 0%, rgba(239, 238, 234, 0.92) 100%)";
  }

  return (
    <AbsoluteFill style={{ zIndex: 0, opacity, overflow: "hidden" }}>
      {isImage ? (
        <Img
          src={fileUrl}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <Video
          src={fileUrl}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          muted
          loop
          startFrom={0}
        />
      )}
      {theme !== "none" && <div style={overlayStyle} />}
    </AbsoluteFill>
  );
};
